<div class="vertical_component_card mb-0">
    <div class="component-list-card h-100 d-flex flex-column pt-0 pb-0">
        <div class="text-center mem_plan_text mb-2 ">
            <div>
                <i *ngIf="errorModel!=null && errorModel['name']!=null"
                    class="pi pi-exclamation-circle float-end me-1 error_color"
                    pTooltip="{{errorModel['name']|translate}}" tooltipPosition="top"></i>
                <input type="text" class="lbl_name lbl_font_style mb-2 text-center input_text_field_dialog "
                    placeholder="{{'BUSINESS.ENTER_NAME'|translate}}" [(ngModel)]="membershipPlanModel.name">

                <i *ngIf="errorModel!=null && errorModel['defaultMonthlyPrice']!=null"
                    class="pi pi-exclamation-circle float-end me-1 error_color"
                    pTooltip="{{errorModel['defaultMonthlyPrice']|translate}}" tooltipPosition="top"></i>
                <input type="text" class="lbl_price lbl_font_style mb-2 text-center input_text_field_dialog "
                    placeholder="{{'BUSINESS.ENTER_MONTHLY_PRICE'|translate}}"
                    [(ngModel)]="membershipPlanModel.defaultMonthlyPrice">

                <i *ngIf="errorModel!=null && errorModel['defaultYearlyPrice']!=null"
                    class="pi pi-exclamation-circle float-end me-1 error_color"
                    pTooltip="{{errorModel['defaultYearlyPrice']|translate}}" tooltipPosition="top"></i>
                <input type="text" class="lbl_price lbl_font_style mb-2 text-center input_text_field_dialog "
                    placeholder="{{'BUSINESS.ENTER_YEARLY_PRICE'|translate}}"
                    [(ngModel)]="membershipPlanModel.defaultYearlyPrice">
            </div>
            <div class="min-h-title">
                <input type="text" class="lbl_title lbl_font_style mb-2 text-center input_text_field_dialog "
                    placeholder="{{'BUSINESS.ENTER_MEMBERSHIP_PLAN_TITLE'|translate}}" [(ngModel)]="membershipPlanModel.title">
                <textarea rows="4" cols="50" class="lbl_desc lbl_font_style mb-2 text-center input_text_field_dialog "
                    placeholder="{{'BUSINESS.ENTER_MEMBERSHIP_PLAN_DESC'|translate}}" [(ngModel)]="membershipPlanModel.description">
                </textarea>
            </div>
            <label class="lbl_num">{{'BUSINESS.NUMBER_OF_VENUES'|translate}}</label>
            <div class="w-100 d-flex">
                <div class="w-50">
                    <i *ngIf="errorModel!=null && errorModel['minNumberOfVenues']!=null"
                        class="pi pi-exclamation-circle float-end me-1 error_color"
                        pTooltip="{{errorModel['minNumberOfVenues']|translate}}" tooltipPosition="top"></i>
                    <input type="number"
                        class="lbl_num_of_ven lbl_font_style mb-2 pb-0 text-center input_num_field_dialog "
                        placeholder="{{'BUSINESS.MIN'|translate}}" [(ngModel)]="membershipPlanModel.minNumberOfVenues">
                </div>
                -
                <div class="w-50">
                    <i *ngIf="errorModel!=null && errorModel['maxNumberOfVenues']!=null"
                        class="pi pi-exclamation-circle float-end me-1 error_color"
                        pTooltip="{{errorModel['maxNumberOfVenues']|translate}}" tooltipPosition="top"></i>
                    <input type="number"
                        class="lbl_num_of_ven lbl_font_style mb-2 pb-0 text-center input_num_field_dialog "
                        placeholder="{{'BUSINESS.MAX'|translate}}" [(ngModel)]="membershipPlanModel.maxNumberOfVenues">
                </div>
            </div>
            <div class="w-100 mb-2">
                <i *ngIf="errorModel!=null && errorModel['countryIds']!=null"
                    class="pi pi-exclamation-circle float-end me-1 error_color"
                    pTooltip="{{errorModel['countryIds']|translate}}" tooltipPosition="top"></i>
                <p-multiSelect [options]="countryItem" [(ngModel)]="membershipPlanModel.countryIds"
                    defaultLabel="{{'BUSINESS.SELECT_COUNTRY'|translate}}" [showHeader]="false" [maxSelectedLabels]="countryItem.length"
                    display="chip" optionLabel="countryName" optionValue="id"></p-multiSelect>

            </div>
        </div>
        <div class="mt-auto">
            <button *ngIf="!enableEdit" class="btn_in_color  me-2" (click)="saveMembershipPlan(membershipPlanModel)">{{
                'SAVE' |
                translate}}</button>
            <button *ngIf="enableEdit" class="btn_in_color  me-2" (click)="editMembershipPlan(membershipPlanModel)">{{
                'EDIT' |
                translate}}</button>
            <button class="btn_without_color btn_border_color " (click)="cancel()">{{ 'CANCEL'
                | translate}}</button>
        </div>
    </div>
</div>
<p-toast position="top-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></p-toast>
